import React, { useState } from 'react';
import { motion } from 'framer-motion';

// Analytics Component
export const Analytics = () => {
  const analyticsData = [
    { metric: 'Page Views', value: '12,543', change: '+15.3%', color: '#00ffff' },
    { metric: 'Unique Visitors', value: '8,921', change: '+8.7%', color: '#ff00ff' },
    { metric: 'Bounce Rate', value: '23.4%', change: '-5.2%', color: '#ffff00' },
    { metric: 'Avg. Session', value: '4m 32s', change: '+12.1%', color: '#00ff00' }
  ];

  return (
    <div style={{ padding: '2rem' }}>
      <motion.h2
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        style={{
          color: '#00ffff',
          fontSize: '2rem',
          marginBottom: '2rem',
          textShadow: '0 0 10px rgba(0, 255, 255, 0.5)'
        }}
      >
        Analytics Dashboard
      </motion.h2>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: '2rem',
        marginBottom: '3rem'
      }}>
        {analyticsData.map((data, index) => (
          <motion.div
            key={data.metric}
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.1 }}
            className="card"
            style={{
              background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.8), rgba(20, 20, 40, 0.9))',
              border: `2px solid ${data.color}40`,
              borderRadius: '16px',
              padding: '2rem',
              backdropFilter: 'blur(15px)'
            }}
          >
            <h3 style={{ color: data.color, margin: '0 0 1rem 0', fontSize: '0.9rem' }}>
              {data.metric}
            </h3>
            <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#ffffff', marginBottom: '0.5rem' }}>
              {data.value}
            </div>
            <div style={{ 
              color: data.change.startsWith('+') ? '#00ff00' : '#ff4444',
              fontSize: '0.9rem',
              fontWeight: 'bold'
            }}>
              {data.change}
            </div>
          </motion.div>
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        className="card"
        style={{
          background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.8), rgba(20, 20, 40, 0.9))',
          border: '2px solid rgba(0, 255, 255, 0.3)',
          borderRadius: '16px',
          padding: '2rem',
          backdropFilter: 'blur(15px)',
          textAlign: 'center'
        }}
      >
        <h3 style={{ color: '#00ffff', marginBottom: '1rem' }}>Traffic Chart</h3>
        <div style={{ 
          height: '300px', 
          background: 'rgba(0, 255, 255, 0.1)', 
          borderRadius: '8px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'rgba(255, 255, 255, 0.7)'
        }}>
          📈 Chart visualization would go here
        </div>
      </motion.div>
    </div>
  );
};

// Messages Component
export const Messages = () => {
  const messages = [
    { id: 1, name: 'John Doe', email: 'john@example.com', subject: 'Project Inquiry', message: 'Hi, I would like to discuss a potential project...', time: '2 hours ago', read: false },
    { id: 2, name: 'Jane Smith', email: 'jane@example.com', subject: 'Collaboration', message: 'I saw your portfolio and would love to collaborate...', time: '1 day ago', read: true },
    { id: 3, name: 'Mike Johnson', email: 'mike@example.com', subject: 'Job Opportunity', message: 'We have an exciting opportunity at our company...', time: '3 days ago', read: false }
  ];

  const [selectedMessage, setSelectedMessage] = useState(null);

  return (
    <div style={{ padding: '2rem' }}>
      <motion.h2
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        style={{
          color: '#00ffff',
          fontSize: '2rem',
          marginBottom: '2rem',
          textShadow: '0 0 10px rgba(0, 255, 255, 0.5)'
        }}
      >
        Messages
      </motion.h2>

      <div style={{ display: 'grid', gridTemplateColumns: selectedMessage ? '1fr 1fr' : '1fr', gap: '2rem' }}>
        <motion.div
          className="card"
          style={{
            background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.8), rgba(20, 20, 40, 0.9))',
            border: '2px solid rgba(0, 255, 255, 0.3)',
            borderRadius: '16px',
            padding: '2rem',
            backdropFilter: 'blur(15px)'
          }}
        >
          <h3 style={{ color: '#00ffff', marginBottom: '1.5rem' }}>Inbox</h3>
          {messages.map((message, index) => (
            <motion.div
              key={message.id}
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.1 }}
              whileHover={{ x: 10, backgroundColor: 'rgba(0, 255, 255, 0.05)' }}
              onClick={() => setSelectedMessage(message)}
              style={{
                padding: '1rem',
                borderRadius: '8px',
                border: '1px solid rgba(0, 255, 255, 0.2)',
                marginBottom: '1rem',
                cursor: 'pointer',
                background: message.read ? 'transparent' : 'rgba(255, 0, 255, 0.05)'
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div>
                  <div style={{ color: '#ffffff', fontWeight: 'bold', marginBottom: '0.3rem' }}>
                    {message.name} {!message.read && <span style={{ color: '#ff00ff' }}>●</span>}
                  </div>
                  <div style={{ color: '#00ffff', fontSize: '0.9rem', marginBottom: '0.3rem' }}>
                    {message.subject}
                  </div>
                  <div style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '0.8rem' }}>
                    {message.message.substring(0, 50)}...
                  </div>
                </div>
                <div style={{ color: 'rgba(255, 255, 255, 0.5)', fontSize: '0.7rem' }}>
                  {message.time}
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>

        {selectedMessage && (
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            className="card"
            style={{
              background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.8), rgba(20, 20, 40, 0.9))',
              border: '2px solid rgba(255, 0, 255, 0.3)',
              borderRadius: '16px',
              padding: '2rem',
              backdropFilter: 'blur(15px)'
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
              <h3 style={{ color: '#ff00ff' }}>Message Details</h3>
              <button
                onClick={() => setSelectedMessage(null)}
                style={{
                  background: 'transparent',
                  border: '1px solid rgba(255, 0, 255, 0.3)',
                  color: '#ff00ff',
                  padding: '0.5rem',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                ✕
              </button>
            </div>
            <div style={{ marginBottom: '1rem' }}>
              <strong style={{ color: '#ffffff' }}>From:</strong> {selectedMessage.name} ({selectedMessage.email})
            </div>
            <div style={{ marginBottom: '1rem' }}>
              <strong style={{ color: '#ffffff' }}>Subject:</strong> {selectedMessage.subject}
            </div>
            <div style={{ marginBottom: '1rem' }}>
              <strong style={{ color: '#ffffff' }}>Time:</strong> {selectedMessage.time}
            </div>
            <div style={{ 
              background: 'rgba(255, 255, 255, 0.05)', 
              padding: '1rem', 
              borderRadius: '8px',
              color: 'rgba(255, 255, 255, 0.9)',
              lineHeight: '1.6'
            }}>
              {selectedMessage.message}
            </div>
            <div style={{ marginTop: '1.5rem', display: 'flex', gap: '1rem' }}>
              <button style={{
                background: 'linear-gradient(45deg, #00ffff, #ff00ff)',
                border: 'none',
                color: '#000',
                padding: '0.8rem 1.5rem',
                borderRadius: '8px',
                cursor: 'pointer',
                fontWeight: 'bold'
              }}>
                Reply
              </button>
              <button style={{
                background: 'rgba(255, 0, 0, 0.2)',
                border: '1px solid rgba(255, 0, 0, 0.3)',
                color: '#ff4444',
                padding: '0.8rem 1.5rem',
                borderRadius: '8px',
                cursor: 'pointer'
              }}>
                Delete
              </button>
            </div>
          </motion.div>
        )}
      </div>
    </div>
  );
};

// Settings Component
export const Settings = () => {
  const [settings, setSettings] = useState({
    notifications: true,
    darkMode: true,
    autoSave: true,
    analytics: true
  });

  const handleToggle = (setting) => {
    setSettings(prev => ({ ...prev, [setting]: !prev[setting] }));
  };

  return (
    <div style={{ padding: '2rem' }}>
      <motion.h2
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        style={{
          color: '#00ffff',
          fontSize: '2rem',
          marginBottom: '2rem',
          textShadow: '0 0 10px rgba(0, 255, 255, 0.5)'
        }}
      >
        Settings
      </motion.h2>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem' }}>
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          className="card"
          style={{
            background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.8), rgba(20, 20, 40, 0.9))',
            border: '2px solid rgba(0, 255, 255, 0.3)',
            borderRadius: '16px',
            padding: '2rem',
            backdropFilter: 'blur(15px)'
          }}
        >
          <h3 style={{ color: '#00ffff', marginBottom: '1.5rem' }}>General Settings</h3>
          
          {Object.entries(settings).map(([key, value]) => (
            <div key={key} style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center',
              marginBottom: '1rem',
              padding: '1rem',
              background: 'rgba(255, 255, 255, 0.05)',
              borderRadius: '8px'
            }}>
              <span style={{ color: '#ffffff', textTransform: 'capitalize' }}>
                {key.replace(/([A-Z])/g, ' $1')}
              </span>
              <motion.div
                onClick={() => handleToggle(key)}
                style={{
                  width: '50px',
                  height: '25px',
                  background: value ? 'linear-gradient(45deg, #00ffff, #ff00ff)' : 'rgba(255, 255, 255, 0.2)',
                  borderRadius: '15px',
                  cursor: 'pointer',
                  position: 'relative',
                  transition: 'all 0.3s ease'
                }}
                whileHover={{ scale: 1.05 }}
              >
                <motion.div
                  style={{
                    width: '21px',
                    height: '21px',
                    background: '#ffffff',
                    borderRadius: '50%',
                    position: 'absolute',
                    top: '2px',
                    left: value ? '27px' : '2px',
                    transition: 'all 0.3s ease'
                  }}
                />
              </motion.div>
            </div>
          ))}
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="card"
          style={{
            background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.8), rgba(20, 20, 40, 0.9))',
            border: '2px solid rgba(255, 0, 255, 0.3)',
            borderRadius: '16px',
            padding: '2rem',
            backdropFilter: 'blur(15px)'
          }}
        >
          <h3 style={{ color: '#ff00ff', marginBottom: '1.5rem' }}>Profile Settings</h3>
          
          <div style={{ marginBottom: '1rem' }}>
            <label style={{ color: '#ffffff', display: 'block', marginBottom: '0.5rem' }}>Name</label>
            <input
              type="text"
              defaultValue="Shankar Soni"
              style={{
                width: '100%',
                padding: '0.8rem',
                background: 'rgba(255, 255, 255, 0.1)',
                border: '1px solid rgba(255, 0, 255, 0.3)',
                borderRadius: '8px',
                color: '#ffffff',
                fontSize: '1rem'
              }}
            />
          </div>
          
          <div style={{ marginBottom: '1rem' }}>
            <label style={{ color: '#ffffff', display: 'block', marginBottom: '0.5rem' }}>Email</label>
            <input
              type="email"
              defaultValue="shankarsoni7172@gmail.com"
              style={{
                width: '100%',
                padding: '0.8rem',
                background: 'rgba(255, 255, 255, 0.1)',
                border: '1px solid rgba(255, 0, 255, 0.3)',
                borderRadius: '8px',
                color: '#ffffff',
                fontSize: '1rem'
              }}
            />
          </div>
          
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            style={{
              background: 'linear-gradient(45deg, #ff00ff, #00ffff)',
              border: 'none',
              color: '#000',
              padding: '1rem 2rem',
              borderRadius: '8px',
              cursor: 'pointer',
              fontWeight: 'bold',
              fontSize: '1rem',
              width: '100%'
            }}
          >
            Save Changes
          </motion.button>
        </motion.div>
      </div>
    </div>
  );
};